import {
  FiAlertTriangle,
  FiCheckCircle,
  FiEdit,
  FiInfo,
  FiTrash2,
  FiXCircle,
} from "react-icons/fi";

// Paleta alinhada ao Figma: ícone de alerta em laranja, demais em azul-petróleo,
// ícone de sucesso em teal (cor do check).
export const ICONS = {
  success: { Icon: FiCheckCircle, color: "#6AB8A8" },
  warning: { Icon: FiAlertTriangle, color: "#F59E0B" },
  error: { Icon: FiXCircle, color: "#D64545" },
  info: { Icon: FiInfo, color: "#0F2C3E" },
  delete: { Icon: FiTrash2, color: "#0F2C3E" },
  edit: { Icon: FiEdit, color: "#0F2C3E" },
};
